module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/AmwayIcons.svg?5v2gxx
// module id = VTS0
// module chunks = 0